export default __webpack_public_path__ + "static/media/04.1f8965a0.jpg";